export default "__VITE_ASSET__0s5mylC6__"